import { EcoaContent } from "@components/common/EconContent";
import { EcoaAuthenticateCodeFlax } from "@maven-rest/cdms/ecoa/EcoaAuthenticateCode.flax";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Footer } from "@layouts/Footer";
import { useLangContext } from "@layouts/home/LangContext";
import { TwoFactorAuthType } from "maven-lib/dist/dto/entity";
import { sessionSlice } from "maven-lib/dist/states";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { HbCodeInput } from "@maven-surface/components/base/HbCodeInput";
import { HbDivider } from "@maven-surface/components/base/HbDivider";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { HbRequestButton } from "@maven-surface/components/base/HbRequestButton";
import { useRoute, useStringParam } from "@maven-surface/hooks/useRoute";
import { CDMS_STUDY_STATUS_CODE } from "@maven-msg/code/cdms/studyStatus";
import { ECOA_ACCESS_CODE_CODE } from "@maven-msg/code/ecoaAccessCode";
import { ECOA_ACCESS_CODE_LANG } from "@maven-msg/lang/ecoaAccessCode";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface IdentityVerificationByBirthProps {}

export function IdentityVerificationByBirth(props: IdentityVerificationByBirthProps) {
  useLangContext();

  const { query } = useRoute();
  const { encryptedAccessCode: encryptedAccessCodeVal } = query;
  const encryptedAccessCode = useStringParam(encryptedAccessCodeVal);

  const [birthYear, setBirthYear] = useState("");

  const nextButtonRef = useRef<HTMLButtonElement>(null);
  const birthYearLength = 4;

  const dispatch = useDispatch();

  function handleBirthYearChange(code: string) {
    setBirthYear(code);
  }

  function handleBirthYearFilledUp() {
    const inputs = nextButtonRef?.current?.parentElement?.getElementsByTagName("button");
    if (!inputs?.length) return;
    inputs[0]?.focus();
  }

  return (
    <>
      <EcoaContent className="app-ecoa-page-home-identity-verification" verticalAlign="CENTER">
        <HbParagraph align="CENTER" margin={2} color="GRAY" text={MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_AUTH_BIRTH_TEXT_LABEL)} />
        <HbDivider space={1} />
        <HbParagraph bold={true} align="CENTER">
          {MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_AUTH_BIRTH_PLACEHOLDER)}
        </HbParagraph>
        <HbCodeInput
          length={birthYearLength}
          code={birthYear}
          onValueChange={handleBirthYearChange}
          onInputCompleted={handleBirthYearFilledUp}
        />

        <HbDivider space={1} />
        <HbButton
          text={MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_INPUT_RESET_TEXT)}
          color="PRIMARY"
          disabled={!birthYear?.trim().length}
          onClick={() => {
            setBirthYear("");
          }}
        ></HbButton>
      </EcoaContent>
      <Footer>
        <HbRequestButton
          elementRef={nextButtonRef}
          text={MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_NEXT)}
          iconRight="ChromeBackMirrored"
          api={{
            ...EcoaAuthenticateCodeFlax.verifyEcoaAuthenticateCode({
              encryptedAccessCode,
              twoFactorAuthType: TwoFactorAuthType.Birth,
              twoFactorAuthValue: birthYear,
            }),
          }}
          delegate={{
            success: (resp) => {
              dispatch(sessionSlice.actions.signIn({ ...resp, redirectTo: "/pat/visits" }));
            },
            error: (error) => {
              if (error?.code === CDMS_STUDY_STATUS_CODE.STUDY_CLOSED.code) {
                dispatch(sessionSlice.actions.signOut());
              }

              return MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_AUTH_BIRTH_FAIL, { message: error }, [
                ECOA_ACCESS_CODE_CODE.ECOA_ACCESS_CODE_NOT_FOUND,
                ECOA_ACCESS_CODE_CODE.ECOA_ACCESS_CODE_RATE_LIMIT,
                ECOA_ACCESS_CODE_CODE.ECOA_BIRTH_YEAR_INVALID,
                ECOA_ACCESS_CODE_CODE.ECOA_BIRTH_YEAR_RATE_LIMIT,
              ]);
            },
          }}
        />
      </Footer>
    </>
  );
}
